import { ButtonEx, ButtonExProps } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { GeotokensContext, useGeotoken } from '../../Contexts'

const OpenSeaButton: React.FC<ButtonExProps> = (props) => {
  const { geotokens } = useContext(GeotokensContext)
  const geotoken = useGeotoken()
  return (
    <ButtonEx
      disabled={!geotoken}
      href={`https://opensea.io/assets/${geotokens?.address()?.toString()}/${geotoken?.quadkey.toBigNumber().toString(10)}/`}
      target="_blank"
      variant="outlined"
      {...props}
    >
      OpenSea
    </ButtonEx>
  )
}

export default OpenSeaButton
